// HeaderThree.jsx
import React, { useCallback, useMemo, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // If Next.js, swap to next/link + usePathname

import logoImg from "../assets/images/resources/logo-2.png";
import heroImg from "@/assets/images/main-slider/slide_v3_1.jpg";

import "@/assets/css/hamburger-menu.css";

export default function HeaderThree() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => setIsMenuOpen((prev) => !prev), []);

  // Close menu on route change (e.g. when user clicks a nav link)
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  // Close menu on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isMenuOpen) setIsMenuOpen(false);
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isMenuOpen]);

  // Simple top navigation to match design (Accueil, À propos, Services, Projects, Contact)
  const navItems = useMemo(
    () => [
      { label: "Accueil", to: "/" },
      { label: "À propos", to: "/about" },
      { label: "Services", to: "/service" },
      { label: "Projects", to: "/projects" },
      { label: "Contact", to: "/contact" },
    ],
    []
  );

  return (
    <section
      className="header-three-hero"
      style={{ backgroundImage: `url(${heroImg})` }}
    >
      <div
        className="header-three-hero__overlay"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <div
          className="site_header__header_three_wrap"
          style={{ border: "none", boxShadow: "none" }}
        >
          <div
            className="topbar-three"
            style={{ border: "none", boxShadow: "none" }}
          >
            <div
              className="container-box"
              style={{ border: "none", boxShadow: "none" }}
            >
              <div
                className="topbar_three_content clearfix header-three-topbar"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="header-three-logo-wrap float-left" style={{ flex: "0 0 auto" }}>
                  <Link to="/" className="main-nag__logo">
                    <img
                      src={logoImg}
                      alt="Company Logo"
                      style={{
                        height: "110px",
                        width: "auto",
                        marginLeft: "220px",
                        marginRight: "80px",
                      }}
                    />
                  </Link>
                </div>

                {/* Desktop nav - hidden on mobile */}
                <div
                  className="topbar_three_nav_box header-three-nav-desktop float-left"
                  style={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <nav
                    className="header-navigation clearfix"
                    style={{ border: "none", boxShadow: "none" }}
                  >
                    <div
                      className="container"
                      style={{ width: "100%", maxWidth: "100%" }}
                    >
                      <div
                        className="main_nav_header_three_content clearfix"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className="main-nav__main-navigation three float-left header-three-main-nav"
                          style={{ flex: 1, display: "flex", justifyContent: "center" }}
                        >
                          <ul
                            className="main-nav__navigation-box"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "48px",
                              listStyle: "none",
                              margin: 0,
                              padding: 0,
                              border: "none",
                              boxShadow: "none",
                            }}
                          >
                            {navItems.map((navItem) => {
                              const isCurrent = location.pathname === navItem.to;
                              return (
                                <li
                                  key={navItem.to}
                                  style={{
                                    listStyle: "none",
                                    border: "none",
                                    boxShadow: "none",
                                  }}
                                >
                                  <Link
                                    to={navItem.to}
                                    style={{
                                      padding: "2px 18px",
                                      borderRadius: "6px",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      letterSpacing: "0.02em",
                                      textTransform: "none",
                                      backgroundColor: isCurrent
                                        ? "#f2c94c"
                                        : "transparent",
                                      color: isCurrent ? "#222222" : "#ffffff",
                                      textDecoration: "none",
                                      border: "none",
                                      boxShadow: "none",
                                    }}
                                  >
                                    {navItem.label}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>

                      </div>
                    </div>
                  </nav>
                </div>

                <div className="topbar_three_right_box header-three-mobile-actions">
                  <button
                    type="button"
                    className={`hamburger-btn ${isMenuOpen ? "is-open" : ""}`}
                    onClick={toggleMenu}
                    aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
                    aria-expanded={isMenuOpen}
                  >
                    <span aria-hidden="true" />
                    <span aria-hidden="true" />
                    <span aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Mobile menu overlay & panel */}
        <div
          className={`hamburger-menu-overlay ${isMenuOpen ? "is-open" : ""}`}
          onClick={toggleMenu}
          onKeyDown={(e) => e.key === "Escape" && toggleMenu()}
          role="button"
          tabIndex={0}
          aria-label="Fermer le menu"
        />
        <aside
          className={`hamburger-menu-panel ${isMenuOpen ? "is-open" : ""}`}
          aria-hidden={!isMenuOpen}
        >
          <nav>
            {navItems.map((navItem) => {
              const isCurrent = location.pathname === navItem.to;
              return (
                <Link
                  key={navItem.to}
                  to={navItem.to}
                  className={`nav-link ${isCurrent ? "active" : ""}`}
                  onClick={toggleMenu}
                >
                  {navItem.label}
                </Link>
              );
            })}
          </nav>
        </aside>

        <div
          className="header-three-hero__content"
          style={{
            textAlign: "center",
            maxWidth: "900px",
            margin: "0 auto",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h1 className="header-three-hero__title">
            LEADERS
            <br />
            AGRO ELITE
          </h1>
          <p className="header-three-hero__text">
            Chez Leaders Agro Elite, nous nous engageons à fournir des services
            agricoles de premier ordre, en mettant l&apos;accent sur la
            durabilité, l&apos;innovation et la qualité. Nos experts agronomes
            travaillent en étroite collaboration avec les agriculteurs locaux
            pour optimiser les rendements, améliorer la santé des sols et
            promouvoir des pratiques respectueuses de l&apos;environnement.
          </p>
          <div className="header-three-hero__actions">
            <Link to="/about" className="thm-btn header-three-hero__btn">
              Découvrez-en plus
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}